export const PremiumSiteRequiredNotificationDataHooks = {
  container: 'premium-site-required-notification-container',
  description: 'premium-site-required-notification-description',
};
